import { render, staticRenderFns } from "./viewerFormItem.vue?vue&type=template&id=79f2f66c&"
import script from "./viewerFormItem.vue?vue&type=script&lang=js&"
export * from "./viewerFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports